import Vue from 'vue'
import Compressor from 'compressorjs'

const notificación = {
	mensaje: {
		activo: false,
		color: '',
		descripción: '',
	},
	error: function(msj) {
		this.mensaje.activo = false
		this.mensaje.descripción = msj
		this.mensaje.color = 'error'
		this.mensaje.activo = true
	},
	correcto: function(msj) {
		this.mensaje.activo = false
		this.mensaje.descripción = msj
		this.mensaje.color = 'green'
		this.mensaje.activo = true
	},
}

const imagen = {
	redimensionarA1000: function(img){
		return this.redimensionarA(img, 1000, '1000px')
	},
	redimensionarA200: function(img){
		return this.redimensionarA(img, 200, '200px')
	},
	redimensionarA: function(img, tamaño, tipo){
		return new Promise((resolve, reject) => {

			let I = new Image()
			I.onload = function() {
				let rta = {
					ancho: this.naturalWidth || this.width,
					alto: this.naturalHeight || this.height
				}

				if (rta.ancho < 100 && rta.alto < 100) {
					reject({ error: 'Imagen muy pequeña.' })
				} else {
					if (rta.ancho < rta.alto) {
						rta.ancho = tamaño
						rta.alto = undefined
					} else {
						rta.alto = tamaño
						rta.ancho = undefined
					}
					resolve(rta)
				}
			}

			I.src = window.URL.createObjectURL(img)

		}).then( rta => {
			return this.redimensionar(img, tipo, rta.ancho, rta.alto).then(rt => {
				if (img.size < rt.imagen.size) {
					rt.imagen = img
				}
				return rt
			})
		})
	},
	redimensionar: function(img, tipo, ancho, alto) {
		return new Promise((resolve, reject) => {
			new Compressor(img, {
				quality: 0.8,
				width: ancho,
				height: alto,
				success(res) {
					resolve({tipo: tipo, imagen: res})
				},
				error(err) {
					console.error('[4370]', err)
					reject({error: '[4370] Ocurrió un error. Es posible que la imagen no tenga un formato adecuado.'})
				}
			})
		})
	},
	tipo: function(arch) {
		let T = 'otro'
		if (arch.type.indexOf('image') === 0) {
			T = 'imagen'
		} else if (arch.type.indexOf('audio') === 0) {
			T = 'audio'
		} else if (arch.type.indexOf('video') === 0) {
			T = 'video'
		}

		return T
	}
}

const manejarCambiosFirebase = function(listado, snapshot, opciones) {
	snapshot.docChanges().forEach( change => {
		let f = () => true
		if (opciones && opciones.filtro && typeof opciones.filtro === 'function') {
			f = opciones.filtro
		}

		let D = Object.assign(change.doc.data(), {identificador: change.doc.id})
		if (change.type === "added") {
			let alInicio = opciones && opciones.agregarAlInicio
			if (f(D)) {
				if (alInicio) {
					listado.splice(0, 0, D)
				} else {
					listado.push(D)
				}
			}
		}
		if (change.type === "modified") {
			for (let i in listado) {
				if (listado[i].identificador === change.doc.id && f(listado[i])) {
					Vue.set(listado, i, D)
					break
				}
			}
		}
		if (change.type === "removed") {
			for (let i in listado) {
				if (listado[i].identificador === change.doc.id && f(listado[i])) {
					Vue.delete(listado, i)
					break
				}
			}
		}
	})
}

const texto = {
	normalizar: function(t) {
		if (t === null || t === undefined) return ''

		if (typeof t === 'number') {
			t = t.toString()
		}

		if (typeof t !== 'string') return ''

		t = t.trim().toLowerCase()
		t = t.replace('á', 'a')
		t = t.replace('é', 'e')
		t = t.replace('í', 'i')
		t = t.replace('ó', 'o')
		t = t.replace('ú', 'u')
		t = t.replace('ü', 'u')

		return t
	},
	contiene: function(texto, buscar) {
		texto = this.normalizar(texto)
		buscar = this.normalizar(buscar)

		if (!buscar) return true
		if (!texto) return false

		return texto.indexOf(buscar) !== -1
	}
}

const fecha = {
	legible: function(f, opcns) {
		if (!f || typeof f !== 'string' || (f.length !== 7 && f.length !== 10)) {
			return f
		}

		let pdzs = f.split('-')
		let año = pdzs[0]
		let mes = this.mapaDeMeses[pdzs[1]]
		if (!año || !mes) {
			return f
		}

		let ahora = new Date()
		let aaaaActual = ahora.getFullYear()
		let mmActual = ahora.getMonth() + 1
		let mesReciente = aaaaActual === Number(año) || (Number(año) === aaaaActual - 1 && Number(pdzs[1]) > mmActual)

		let t = ''

		if (pdzs.length === 3) {
			t = `${Number(pdzs[2])} de `
		}

		t += mes

		if (!mesReciente || (opcns && opcns.forzarAño)) {
			t += ` de ${año}`
		}

		return t
	},
	mapaDeMeses: {
		'01': 'enero',
		'02': 'febrero',
		'03': 'marzo',
		'04': 'abril',
		'05': 'mayo',
		'06': 'junio',
		'07': 'julio',
		'08': 'agosto',
		'09': 'septiembre',
		'10': 'octubre',
		'11': 'noviembre',
		'12': 'diciembre'
	}
}

const número = function(n) {
	if (n === undefined || n === null || n === false) {
		return ''
	}

	n = Intl.NumberFormat('es').format(n)
	if (n === 'NaN') {
		return ''
	}

	return n
}

const moneda = function(n) {
	n = número(n)
	if (!n) {
		return ''
	}

	return '$' + n
}

export { notificación, imagen, manejarCambiosFirebase, texto, fecha, número, moneda }